import { withLoader } from 'util/routeHelper';

export default store => ({
	path: 'team',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'team',
				),
			store,
			'TEAM',
		),
	},
});



// WEBPACK FOOTER //
// ./src/routes/Team/index.js